import { Center, Switch, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import { useState } from "react";
import { DataTable } from "../../../../components/DataTable";
import { mapScopeOneFactorsData } from "../helpers";
import { sortAlphabeticallyByAttribute } from "../../../../utils";
import { useTranslation } from "react-i18next";
import { toggleConversionFactorEnabled } from "../../../../api/conversion-factors/conversion-factors";

const TYPES = Object.freeze({
  "PURCHASED_FUELS": "PURCHASED_FUELS",
  "PURCHASED_ELECTRICITY": "PURCHASED_ELECTRICITY"
});

function ScopeThreeCategoryThreeFactors({ data, organizationStructure }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "conversionFactors"
  });
  const { t: globalTranslation } = useTranslation("translation");
  const [tabIndex, setTabIndex] = useState(0);

  const getMappedData = (type) => {
    if (type === TYPES.PURCHASED_FUELS) {
      return mapScopeOneFactorsData(data.categoryThreePurchasedFuels);
    } else if (type === TYPES.PURCHASED_ELECTRICITY) {
      return data.categoryThreeElectricity
        .map(el => {
          return {
            country: el.location,
            purchasedElectricityConversionFactor: el.purchasedElectricityConversionFactor,
            lossesElectricityConversionFactor: el.lossesElectricityConversionFactor,
            source: el.source ?? ""
          };
        })
        .sort((a, b) => sortAlphabeticallyByAttribute(a, b, "country"));
    }
    return [];
  };

  const enabledColumn = {
    header: t("headers.enabled"),
    accessorKey: "_enabled",
    size: 80,
    enableColumnFilter: false,
    enableSorting: false,
    cell: ({ row }) => (
      <Switch
        size="sm"
        colorScheme="green"
        defaultChecked={true}
        onChange={(e) => toggleConversionFactorEnabled({
          scope: "scope3cat3",
          typeId: row.original._consumptionTypeId || row.original.country,
          typeName: row.original._consumptionTypeName || row.original.country,
          enabled: e.target.checked,
        })}
      />
    ),
  };

  const getColumns = (type) => {
    if (type === TYPES.PURCHASED_FUELS) {
      return [
        enabledColumn,
        {
          header: t("headers.consumptionType"),
          accessorKey: "consumptionType",
          size: 150
        },
        {
          header: t("headers.measurementUnit"),
          accessorKey: "measurementUnit",
          size: 100
        },
        {
          header: t("headers.conversionFactor"),
          accessorKey: "conversionFactor",
          size: 200,
          enableColumnFilter: false
        },
        {
          header: t("headers.calorificValue"),
          accessorKey: "calorificValue",
          size: 200,
          enableColumnFilter: false
        },
        {
          header: t("headers.source"),
          accessorKey: "source",
          size: 150
        }
      ];
    } else if (type === TYPES.PURCHASED_ELECTRICITY) {
      return [
        enabledColumn,
        {
          header: t("headers.country"),
          accessorKey: "country",
          size: 200
        },
        {
          header: t("headers.purchasedElectricityConversionFactor"),
          accessorKey: "purchasedElectricityConversionFactor",
          size: 200,
          enableColumnFilter: false
        },
        {
          header: t("headers.electricityLossesConversionFactor"),
          accessorKey: "lossesElectricityConversionFactor",
          size: 200,
          enableColumnFilter: false
        },
        {
          header: t("headers.source"),
          accessorKey: "source",
          size: 150
        }
      ];
    }
    return [];
  };

  return (
    <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex} isLazy>
      <Center>
        <TabList borderBottom="none">
          <Tab _focus={{ boxShadow: "none" }}>{t("tabs.purchasedFuels")}</Tab>
          <Tab _focus={{ boxShadow: "none" }}>{t("tabs.purchasedElectricity")}</Tab>
        </TabList>
      </Center>
      <TabPanels marginTop={5}>
        <TabPanel padding="0">
          {getMappedData(TYPES.PURCHASED_FUELS)?.length === 0 ?
            <Text fontSize="lg" fontWeight="bold">
              {globalTranslation("noDataAvailable")}
            </Text> :
            <DataTable
              data={getMappedData(TYPES.PURCHASED_FUELS)}
              columns={getColumns(TYPES.PURCHASED_FUELS)}
              enableFilters={true}
            />
          }
        </TabPanel>
        <TabPanel padding="0">
          {getMappedData(TYPES.PURCHASED_ELECTRICITY)?.length === 0 ?
            <Text fontSize="lg" fontWeight="bold">
              {globalTranslation("noDataAvailable")}
            </Text> :
            <DataTable
              data={getMappedData(TYPES.PURCHASED_ELECTRICITY)}
              columns={getColumns(TYPES.PURCHASED_ELECTRICITY)}
              enableFilters={true}
            />
          }
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}

export default ScopeThreeCategoryThreeFactors;